var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('VueSelect', _vm._b({
    attrs: {
      "value": _vm.value,
      "options": _vm.opcoesComCadastroRapido,
      "label": _vm.label,
      "filterable": false,
      "disabled": _vm.disabled || _vm.creating,
      "loading": _vm.searching || _vm.creating
    },
    on: {
      "input": _vm.onInput,
      "open": _vm.onOpen,
      "search": _vm.onSearch
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [option.__cadastroRapido ? _c('div', {
          staticClass: "cadastro-rapido-option"
        }, [_c('span', {
          staticClass: "cadastro-rapido-option__icon"
        }, [_vm._v("+")]), _c('span', [_vm._v("Criar " + _vm._s(_vm.entityLabel) + " “" + _vm._s(option[_vm.label]) + "”")])]) : _vm._t("option", function () {
          return [_vm._v(" " + _vm._s(option[_vm.label]) + " ")];
        }, null, option)];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_vm._t("selected-option", function () {
          return [_vm._v(" " + _vm._s(option[_vm.label]) + " ")];
        }, null, option)];
      }
    }], null, true)
  }, 'VueSelect', _vm.$attrs, false), [_c('template', {
    slot: "no-options"
  }, [_vm._t("no-options", function () {
    return [_vm._v("Digite para pesquisar")];
  })], 2)], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };